import { Switch } from '@mui/material'
import React, { useState } from 'react'

interface AttributionModelConfigProps {
  theme: {
    textPrimary: string
    textSecondary: string
    border: string
    cardBackground: string
  }
}

// Attribution Model panel (attribution dashboards only).
// Static/local for now — not yet wired into Run analysis.
const AttributionModelConfig: React.FC<AttributionModelConfigProps> = ({ theme }) => {
  const [factorAttribution, setFactorAttribution] = useState<boolean>(true)
  const [brinsonAttribution, setBrinsonAttribution] = useState<boolean>(false)

  const noModelSelected = !factorAttribution && !brinsonAttribution

  const toggleCard = (
    title: string,
    description: string,
    checked: boolean,
    onChange: (value: boolean) => void,
    disabled = false,
  ) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        padding: '12px 16px',
        border: `1px solid ${theme.border}`,
        borderRadius: '8px',
        backgroundColor: theme.cardBackground,
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <div>
        <div style={{ fontWeight: 600, fontSize: '14px', color: theme.textPrimary }}>{title}</div>
        <div style={{ fontSize: '12px', color: theme.textSecondary }}>{description}</div>
      </div>
      <Switch checked={checked} onChange={(e) => onChange(e.target.checked)} disabled={disabled} />
    </div>
  )

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', minWidth: '260px' }}>
      <label style={{ fontWeight: 600, fontSize: '14px', color: theme.textPrimary }}>Attribution Model</label>
      {toggleCard('Factor Attribution', 'Style/Macro decomposition', factorAttribution, setFactorAttribution)}
      {toggleCard(
        'Brinson Attribution',
        'Allocation, selection, interaction',
        brinsonAttribution,
        setBrinsonAttribution,
        true,
      )}
      {noModelSelected && (
        <div style={{ fontSize: '12px', color: '#d32f2f' }}>
          Please select an attribution model before running the analysis.
        </div>
      )}
    </div>
  )
}

export default AttributionModelConfig
